import { dataProps, itemListProps } from './properties'

export const setEmployeePayrollList = (state, payload) => {
    state.list = payload.response
    state.nav.total = payload.total
state.nav.page_number = payload.page_number
    if(!state.nav.had_results) {
        state.nav.had_results = payload.total>0
    }
}    

export const setEmployeePayrollData = (state, payload) => {
    state.props = payload.response
    
    if(state.props.payroll_item_list.length === 0) {
        state.props.payroll_item_list = [JSON.parse(JSON.stringify(itemListProps))]
    }
    
} 

export const addNewEmployeePayrollItemListRow = state => {

    let key = 0
    state.props.payroll_item_list.push(JSON.parse(JSON.stringify(itemListProps)))

    state.props.payroll_item_list.forEach(element => {
        element.key = key
        key ++
    })

    setTimeout(() => {
        document.getElementById('item_id_'+(key-1)).focus()
    }, 300);

}

export const removeEmployeePayrollItemListRow = (state, payload) => {

    let key = 0

    state.props.payroll_item_list.splice(payload, 1)
    
    if(state.props.payroll_item_list.length === 0) {
        state.props.payroll_item_list = [JSON.parse(JSON.stringify(itemListProps))]
    }

    state.props.payroll_item_list.forEach(element => {
        element.key = key
        key ++
    })

}

export const setFreshPayrollInformation = (state, payload) => {
   
    state.props.production_work_list = payload.production_logs
    state.props.attendance_list = payload.attendance
    state.props.sales_commission_list = payload.sales_commission
    state.props.loan_repayment_list = payload.loan_repayment
    state.props.payroll_item_list = payload.particulars

    state.props.deduction_per_day = payload.deduction_per_day
    state.props.overtime_list = payload.overtime_list

}

export const resetEmployeePayrollData = state => {
    state.props = JSON.parse(JSON.stringify(dataProps))
}


// WEBPACK FOOTER //
// ./src/store/modules/employeePayroll/mutations.js